import React from "react";
const context = React.createContext();

export default context;

export const useContext = () => {
    return React.useContext(context);
}